import actionTypes from '../constants/actionTypes/calculation-data-action-types';

export const reducer = (
    state = {
        isFetching: false,
        error: false,
        calculatedData: {},
        caughtError: {}
    },
    action
) => {
    switch (action.type) {
        case actionTypes.REQUEST:
        case actionTypes.REQUEST_UPDATE:
        case actionTypes.REQUEST_BUY:
            return { ...state, isFetching: true };

        case actionTypes.RECEIVE:
            let calculatedOffer = action.payload;
            return {
                ...state,
                isFetching: false,
                calculatedData: calculatedOffer,
                error: false
            };

        case actionTypes.FETCH_ERROR:
            let caughtError = action.payload.errorMessage;
            return {
                ...state,
                isFetching: false,
                error: true,
                caughtError: caughtError
            };
        case actionTypes.UPDATE_CALCULATION:
            return {
                ...state,
                calculatedData: {
                    ...state.calculatedData,
                    calculation: { ...action.payload }
                }
            };
        default:
            return state;
    }
};

export default reducer;
